var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('child-toolbar',{attrs:{"title":_vm.title,"buttons":_vm.buttons}}),_vm._v(" "),(_vm.loaded)?_c('bt-realization-expense-form',{ref:"form",attrs:{"value":_vm.expense},on:{"input":_vm.change}}):_c('h2',[_vm._v("Loading...")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1357bb4c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bt-realization/BtRealizationExpenseNew.vue
// module id = null
// module chunks = 